import { render, staticRenderFns } from "./ConfirmedGroups.vue?vue&type=template&id=97cf9850&"
import script from "./ConfirmedGroups.vue?vue&type=script&lang=js&"
export * from "./ConfirmedGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports